// ----------------------------------------------------------------------
// <copyright file="Izenda.RolesCopySetting.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

/**
 * Mapping component
 */
!(function () {
  "use strict";

  var React = require('react');
  var connect = require('share/enhancers/Izenda.Connect');
  var classnames = require('classnames');

  var Input = require('share/components/controls/Izenda.Input');
  var EventUtils = require('EventUtils');
  var Panel = require('share/components/controls/Izenda.Panel');
  var GridLayout = require('share/components/controls/Izenda.GridLayout');
  const {isEmpty, find, chunk} = require('lodash/fp');

  var RolesCopySetting = connect()(function (props) {
      var header = {
      title: props.permissionSetting ? 'Roles & Permissions Copy Settings' : 'Roles Copy Settings',
      icon: 'icon-toggle-triangle',
      className: 'u_noPaddingLeft u-bgGray'
      };
    var store = props.store;
      return (
        <Panel  header={header}
                className='header-section'
                collapsible
                expanedOption
                id={props.id} >
                <PanelBody store={store} permissionSetting={props.permissionSetting} />
        </Panel>
      );
  });

  var PanelBody = connect()(function (props) {
    var store = props.store;
    var item = store.item;
    var selectedSource =  find({'id': item.sourceId}, store.tenantList);
    var headerText = props.localization.getText('COPY_MANAGEMENT_WORKSPACE_DETAIL_LABEL_SELECT_ROLES_TO_COPY');
    var fn = props.permissionSetting ? item.selectAllRolePermissions.bind(item) : item.selectAllRole.bind(item);
    var checked = props.permissionSetting ? item.allRoleCopyPermissionChecked : item.allRoleCopyChecked;
    var listRoles = props.permissionSetting ? item.roleListPermission : item.roleList;

    return (
      <GridLayout>
        <GridLayout.Row className='u_noMarginAll u-bgLightBlue u_paddingAll'>
          <span className='u_marginLeft'>{headerText}</span>
        </GridLayout.Row>
        <GridLayout.Row className='u_noMarginAll u_borderAll u_paddingAll'>
          {
            ! isEmpty(listRoles) &&
              <GridLayout.Col cols='12'>
                <GridLayout.Col cols='3'>
                  <label>
                    <Input type='checkbox'
                           checked={checked}
                           onChange={EventUtils.notifyChange(fn, EventUtils.CHECKBOX)}
                           />
                    <span>All</span>
                  </label>
                </GridLayout.Col>

                <ListTenant store={store} permissionSetting={props.permissionSetting} />
              </GridLayout.Col>
          }
        </GridLayout.Row>
      </GridLayout>
    );
  });

  var ListTenant = connect()(function (props) {
    var store = props.store;
    var item = store.item;
    var listRoles = props.permissionSetting ? item.roleListPermission : item.roleList;
    var copiedRoleType = props.permissionSetting ? 'copiedRolePermission' : 'copiedRoles';
    var chunkOptions =  chunk(4, listRoles);
    var renderTenant = function(items) {
      var listTenant = [];
      items.forEach(function (tenant){
        listTenant.push(
          <GridLayout.Col cols='3' key={tenant.id}>
            <label className='u_textTruncate'>
              <Input type='checkbox'
                     key={tenant.id}
                     value={tenant.id}
                     checked={tenant.checked}
                     onChange={EventUtils.notifyChange(item.selectedRoleCopy.bind(item, listRoles, copiedRoleType, tenant.id), EventUtils.CHECKBOX)}
                     />
            <span title={tenant.name}>{tenant.name}</span>
            </label>
          </GridLayout.Col>
        );
      });
      return listTenant;
    };
    return (
      <GridLayout.Col cols='9'>
        <GridLayout.Row>
          <GridLayout.Col cols='12'>
            {chunkOptions.map(function (items, index) {
              return (
                  <GridLayout.Row key={index}>
                    {renderTenant(items)}
                  </GridLayout.Row>
                );
              })
            }
          </GridLayout.Col>
        </GridLayout.Row>
      </GridLayout.Col>
    );
  });

  module.exports = connect()(RolesCopySetting);
}());



// WEBPACK FOOTER //
// ./ui/modules/Settings/DataSetup/CopyManagement/WorkspaceDetail/RolesCopy/Izenda.RolesCopySetting.jsx